export default __webpack_public_path__ + "static/media/faucet.4346944a.jpg";